var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.column.type == "cascader_radio"
        ? _c(
            "div",
            { staticClass: "text-ellipsis" },
            _vm._l(_vm.row[_vm.column.prop], function (field, inx) {
              return _c(
                "span",
                {
                  key: inx,
                  staticClass: "ml-a-span",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.downField(field.url, field.name)
                    },
                  },
                },
                [_vm._v(_vm._s(inx > 0 ? "/" : "") + _vm._s(field))]
              )
            }),
            0
          )
        : _c("div", { staticClass: "text-ellipsis" }, [
            _vm._v(_vm._s(_vm.row[_vm.column.prop] || _vm.row.sumcol)),
          ]),
      _vm._v(" "),
      _c(
        "zbDialog",
        {
          attrs: { title: "文件下载", appendToBody: "", width: "400px" },
          model: {
            value: _vm.filesDialog,
            callback: function ($$v) {
              _vm.filesDialog = $$v
            },
            expression: "filesDialog",
          },
        },
        [
          _c(
            "el-scrollbar",
            { attrs: { "max-height": "400px" } },
            _vm._l(_vm.filesList, function (field, inx) {
              return _c("div", { key: inx, staticClass: "field-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "ml-a-span",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.downField(field.url, field.name)
                      },
                    },
                  },
                  [_vm._v(_vm._s(field.name))]
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "zbDialog",
        {
          attrs: { title: "点击图片预览", appendToBody: "", width: "400px" },
          model: {
            value: _vm.previewDialog,
            callback: function ($$v) {
              _vm.previewDialog = $$v
            },
            expression: "previewDialog",
          },
        },
        [
          _c(
            "div",
            { staticClass: "preview-box" },
            [
              _c("el-image", {
                attrs: {
                  src: _vm.formatUrl(_vm.previewUrl),
                  "zoom-rate": 1.2,
                  "max-scale": 7,
                  "min-scale": 0.2,
                  "preview-src-list": [_vm.formatUrl(_vm.previewUrl)],
                  "initial-index": 4,
                  fit: "cover",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }